import type { WP_REST_API_Attachment } from 'wp-types';

export type WpMedia = WP_REST_API_Attachment;

export default (fetch: typeof $fetch) => ({
  getById: async (id: string) => {
    const response = await fetch<WpMedia>(`wp/v2/media/${id}`);
    return response;
  }
});
